export default __webpack_public_path__ + "static/media/cad_sheet.5ff58f4b.svg";